import { t } from "i18next";

import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, SxProps, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

import { addThousandsSeparator } from "@/src/utils/numberUtils";

interface BidMachineInfoProps {
  id: number;
  maxAmount: number;
  guaranteedAmount?: number;
  onDeactivateBidMachine?: () => void;
  onEditBidMachine?: () => void;
  sx?: SxProps;
}

const BidMachineInfo = (props: BidMachineInfoProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        border: "1px solid",
        borderRadius: 2,
        borderColor: theme.palette.divider,
        ...props.sx
      }}
    >
      <Box sx={{ width: "100%", p: 1 }}>
        <Box
          sx={{
            width: "100%"
          }}
        >
          {t("components.bidMachineInfo.bidMachine")}
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          }}
        >
          <Typography sx={{ mb: 0.5 }}>
            {t("components.bidMachineInfo.bidMachineMaxValue")}
          </Typography>
          <Typography
            variant="h6"
            sx={{ pl: 1, color: theme.palette.semantic.warning.main, mb: 0.5 }}
          >
            {addThousandsSeparator(props.maxAmount)}
            {"€"}
          </Typography>
        </Box>
        {props.guaranteedAmount && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              mt: -0.5
            }}
          >
            {t("components.bidMachineInfo.guaranteedAmount")}
            <Typography
              variant="h6"
              sx={{ pl: 1, color: theme.palette.semantic.warning.main, mb: 0 }}
            >
              {addThousandsSeparator(props.guaranteedAmount.toFixed(0))}
              {"€"}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around"
        }}
      >
        <IconButton
          id={`${props.id}BidMachineCloseButton`}
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (props.onDeactivateBidMachine) {
              props.onDeactivateBidMachine();
            }
          }}
        >
          <Delete fontSize="small" />
        </IconButton>
        <IconButton
          id={`${props.id}BidMachineEditButton`}
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (props.onEditBidMachine) {
              props.onEditBidMachine();
            }
          }}
        >
          <Edit fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default BidMachineInfo;
